// Module
var code = `<div class="range-control-container">
    <div class="range-control" on-mousedown="onMouseDownMain">

        {{#if .isRevers}}
            <div class="rangeControl-active-bar" style="left: {{.slid_position_end}}px; width: {{.slid_position_start - slid_position_end}}px;"></div>
        {{else}}
            <div class="rangeControl-active-bar" style="left: {{.slid_position_start}}px; width: {{.slid_position_end - slid_position_start}}px;"></div>
        {{/if}}

        <div class="rangeControl-slider" style="left: {{.slid_position_start}}px;" as-tooltip="startDayTooltip" on-mousedown="onMouseDownStart" on-mouseup="onMouseUpStart" {{#.focusedStart}}focused=""{{/}}>
            <div class="rangeControl-clock" style="left: {{.clock_position_start}}px;">
                <div class="rangeControl-clock-text" as-tooltip="startDayTooltip">{{.valueClockStart}}</div>
            </div>
        </div>

        <div class="rangeControl-slider" style="left: {{.slid_position_end}}px;" as-tooltip="endDayTooltip" on-mousedown="onMouseDownEnd" on-mouseup="onMouseUpEnd" {{#.focusedEnd}}focused=""{{/}}>
            <div class="rangeControl-clock" style="left: {{.clock_position_end}}px;">
                <div class="rangeControl-clock-text" as-tooltip="endDayTooltip">{{.valueClockEnd}}</div>
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;